<template>
    <div class="unselectable" style="display: flex;flex-direction: column; gap: 10px; position: relative;" :style="{width: `${size}px`}">
        <!-- <div class="modeSelector" style="" v-if="file">
            <div class="mode" :class="{active: !isFile}" @click="setIsFile(false)">
                Webcam
            </div>
            <div class="mode" :class="{active: isFile}" @click="setIsFile(true)">
                File
            </div>
        </div>  -->
        <div v-if="floatingConfig" style="display: flex; gap: 5px; justify-content: space-between; position: relative; z-index: 1">
            <DropdownMenu v-if="webcam && localDevices" v-show="!isFirst && !isFile" :blue="blue" :purple="purple" :icon="cameraImage" @input="webcam.set($event)" :value="localDeviceID" :choices="localDevices" />
            <div style="display: flex; gap: 5px; align-items: center;" v-if="webcam && !isFile">
                <img class="triggerBtn" src="../assets/flip.svg" @click="webcam.flip">
                <img class="triggerBtn" style="width: 28px;" src="../assets/play.svg" @click="play" v-if="isStop">
                <img class="triggerBtn" style="width: 28px;" src="../assets/pause.svg" @click="pause" v-else>
                <label style="height: 24px;" v-if="file">
                    <img class="triggerBtn" style="width: 24px; height: 24px;" src="../assets/image.svg" @click="pause">
                    <input type="file" @input="uploadEvt" onclick="this.value=null;" style="display: none;"> 
                </label>
            </div>
        </div>
        <div class="camera" :style="{width: `${size}px`, height: `${size}px`}" style="position: relative;">
            <div class="onHover" >
                <div style="display: flex; flex-direction: column; gap: 5px; align-items: flex-end; position: relative;">
                    <div style="display: flex; gap: 5px" v-if="webcam && !isFile && !floatingConfig">
                        <img class="triggerBtn" src="../assets/flip.svg" @click="webcam.flip">
                        <img class="triggerBtn" style="width: 28px;" src="../assets/play.svg" @click="play" v-if="isStop">
                        <img class="triggerBtn" style="width: 28px;" src="../assets/pause.svg" @click="pause" v-else>
                    </div>
                    <div style="display: flex; gap: 5px; position: relative;" v-if="file || (floatingConfig) ">
                        <label v-show="(!floatingConfig && file) || (floatingConfig && isFile)">
                            <img class="triggerBtn" style="width: 28px;" src="../assets/image.svg" @click="pause">
                            <input type="file" @input="uploadEvt" onclick="this.value=null;" style="display: none;"> 
                        </label>
                        <img class="triggerBtn" style="width: 28px;" src="../assets/back.svg" @click="isFile = false" v-show="isFile">
                    </div>
                </div>
            </div>
            <DropdownMenu v-if="webcam && localDevices && !floatingConfig" v-show="!isFirst && !isFile" :blue="blue" :purple="purple" :icon="cameraImage" class="onHover" @input="webcam.set($event)" :value="localDeviceID" :choices="localDevices" style="left: 10px; flex: 1;" />
            <canvas class="canvas" ref="canvas" :width="resolution" :height="resolution" style="width: 100%; height: 100%; "/>
            <div v-if="webcam && !webcam.permission" 
                    style="width: 100%; height: 100%; background: #ED4337; line-height: 24px; padding: 30px;
                    position: absolute; top: 0; z-index: 100; text-align: center;
                    color: white; display: flex; justify-content: center; align-items: center; font-size: 18px;">
                Please Enable Webcam Permission
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
import Camera from '../scripts/camera.js'
import cameraImage from '../assets/camera.png'

import Button from '@/tm/Button.vue'
import DropdownMenu from '@/ui/DropdownMenu'
import { watchObjProp } from '@/utils'

export default {
    name: 'Camera',
    emits: ['update', 'start'],
    props: {
        file: {
            type: Boolean,
            default: true
        },
        blue: {
            type: Boolean,
            default: false
        },
        purple: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 240
        },
        resolution: {
            type: Number,
            default: 224
        },
        camera: {
            type: Object,
            default: null
        },
        floatingConfig: {
            type:Boolean,
            default: false
        }
    },
    components: {
        DropdownMenu,
        Button
    },
    data () {
        return {
            localDeviceID: null,
            localDevices: null,
            isFile: false,
            cameraImage: cameraImage,
            canvas: null,
            isFirst: true,
            isStop: false,
            webcam: null
        }
    },
    methods: {
        uploadEvt(event){
            const file = event.target.files[0]
            const reader = new FileReader();
            
            reader.onload = (e) => {
                const image = new Image();
                image.width = this.resolution;
                image.height = this.resolution;
                image.src = e.target.result

                image.onload = () => {
                    const ctx = this.canvas.getContext('2d')
                    ctx.clearRect(0, 0, this.resolution, this.resolution);
                    ctx.drawImage(image, 0, 0, this.resolution, this.resolution);
                    this.$emit('update', this.canvas);
                    this.isFile = true;
                }
            };
            
            reader.readAsDataURL(file);
        },
        start(){
            this.webcam.play();

            const ctx = this.canvas.getContext('2d')
            this.webcam.loop((croppedCanvas)=>{
                if (this.isFirst) {
                    this.isFirst = false
                    this.$emit('start')
                }
                if(!this.isFile && croppedCanvas) {
                    ctx.drawImage(croppedCanvas, 0, 0, this.resolution, this.resolution);
                    this.$emit('update', croppedCanvas, ctx);
                }
            })
        },
        play(){
            this.webcam.play();
        },
        pause(){
            this.webcam.stop();
        },
        status(){
            return !!this.webcam.device
        },
        setIsFile(val){
            this.isFile = val
            if(this.isFile) {
                this.canvas.getContext('2d').clearRect(0, 0, this.resolution, this.resolution);
            }
        }
    },
    async mounted(){   
        this.canvas = this.$refs.canvas;

        if (this.camera) {
            this.webcam = this.camera
        } else {
            this.webcam = new Camera(this.resolution, this.resolution, true)
        }

        watchObjProp(this.webcam, 'deviceId', (newValue) => {
            this.localDeviceID = newValue;
        })

        watchObjProp(this.webcam, 'devices', (newValue) => {
            this.localDevices = newValue;
        })

        watchObjProp(this.webcam, 'isStop', (newValue) => {
            this.isStop = newValue
        })

        this.start();
    },
    beforeUnmount(){
        this.webcam.stop();
    }
}
</script>

<style scoped>
.onHover{
    opacity: 0.3;
    transition: .3s all ease-in-out;
    position: absolute;
    z-index: 12;
    top: 15px; 
    right: 10px;
}


.camera:hover .onHover{
    opacity: 1;
}

.triggerBtn{
    color: white;
    cursor: pointer;
    width: 24px;
    height: auto;
    border-radius: 50%;
    filter: drop-shadow(0 0 5px #000);
    position: relative;
}

.triggerBtn:hover{
    transform: scale(1.2);
}

.canvas {
    background-color: rgba(255, 255, 255, 0.3);
    width: 240px; height: 240px;
    border-radius: 10px;
}

.modeSelector{
    width: 100%; padding: 5px 3px; font-size: 16px; display: flex; align-items: center; gap: 5px;
    
}

.mode, .mode:not(.active):hover{
    width: 50%; height: 35px; background: #8A66C7; 
    border-radius: 3px; color: white; display: flex; 
    justify-content: center; align-items: center;
    cursor: pointer;
}

.mode:not(.active){
    background: gray;
}
</style>

<style scoped>
input[type='file']{
    cursor: pointer;
    font-size: 0;
    opacity: 0.0; position: absolute; 
    top: 0; left: 0; bottom: 0; right: 0; 
    width: 100%; height:100%; z-index: 1; cursor: pointer
}

input[type="file"] > input { cursor: inherit }

.uploadBtn{
    position: absolute; top: calc(100% - 30px); left: 50%; transform: translate(-50%, -100%); opacity: 0.5; 
    z-index: 2;
}

.uploadBtn:hover{
    opacity: 1;
}
</style>